import styled from "styled-components";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box as BoxUI, Button, InputLabel, TextField } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export const Container = styled.div``;

export const Content = styled.div`
  margin: 24px 24px;
  min-width: 1034px;
`;

export const Row = styled.div`
  display: flex;
`;

export const Column = styled.div`
  margin-right: 25px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  padding: 24px 22px;
  align-items: center;
  justify-content: space-between;
  width: 470px;
  background: #fafafa;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
`;

export const ContainerLeft = styled.div``;

export const ContainerRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  padding: 8px 16px;
  border-radius: 8px;

  button {
    border: solid 1px #000000;
    border-radius: 18px;
    height: 36px;
    padding: 0 15px;
  }
`;

export const ContainerAccordionHeader = styled.div`
  display: flex;
  width: 100%;
  padding-right: 52px;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerStatus = styled.div<{ colorTheme?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 3px 6px;
  height: 24px;
  width: auto;
  gap: 4px;

  border: 1px solid
    ${({ theme, colorTheme }) =>
      colorTheme === "primary"
        ? theme.palette.primary.main
        : theme.palette.secondary.main};
  span {
    line-height: 0;
  }
`;

export const CantainerButtom = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 22px;
`;

export const CantainerCardFinished = styled.div`
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 16px;
  width: auto;
  left: 20px;
  top: 2748px;
  margin: 1rem 24px;
  justify-content: space-between;
  height: 75px;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  animation: initialAnimated 0.4s;

  @keyframes initialAnimated {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const ConatinerFinishedButtom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const CantainerName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerCardFinalized = styled.div``;

// export const ContainerDetais = styled.div`
//   display: flex;
//   background: #ffffff;
//   max-width: 600px;
//   min-width: 570px;
//   margin-top: -90px;
//   height: calc(100vh - 138px);
// `;

export const ContainerDetais = styled.div<{ fullHeight?: boolean }>`
  display: flex;
  background: #ffffff;
  max-width: 600px;
  min-width: 570px;
  height: ${({ fullHeight }) => (fullHeight ? "100vh" : "calc(100vh - 192px)")};
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  overflow-y: auto;
  width: 470px;
  min-width: 220px;
  height: calc(100vh - 230px);
  gap: 16px;
  padding: 16px 16px 32px;
`;

export const ContainerOrders = styled.div`
  display: flex;
`;

export const ContentModal = styled(BoxUI)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: auto;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 24px 24px;
  justify-content: center;
  align-items: center;
`;

export const TitleHeader = styled.div`
  display: flex;
  margin: 10px 0;
`;

export const TitleBody = styled.div`
  display: flex;
  margin-top: 5px;
  margin-bottom: 30px;
`;

export const ButtonModal = styled(Button)`
  display: flex;
`;

export const ButtonSwipeable = styled(LoadingButton)<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 30px !important;
  background: ${({ theme, disabled }) =>
    disabled ? "lightgray" : theme.palette.primary.main};
  border-radius: 21px !important;
  border-width: 0;
  cursor: pointer;
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.text.disabled : "white"};
`;

export const SwipeableInputContainer = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TitleHeaderCode = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-weight: bold;

  p {
    font-size: 18px;
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: start;
  }
`;

export const TitleBodyCode = styled.div`
  display: flex;
  margin-top: 5px;
  margin-bottom: 30px;
  width: 476px;
`;

export const ButtonModalCode = styled(Button)`
  display: flex;
  width: 296px;
  border-radius: 20px !important;
`;

export const Image = styled.img`
  margin-bottom: 35px;
`;

export const Separator = styled.div`
  margin-right: 30px;
`;

export const TitleBodyCodeOtp = styled.div`
  display: flex;
  margin-top: 5px;
  margin-bottom: 30px;
  width: 476px;
  justify-content: center;
`;

export const ContentModalOTP = styled(BoxUI)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 444px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 24px 24px;
  justify-content: center;
  align-items: center;
`;

export const ButtonModalCodeOTP = styled.button`
  display: flex;
  border-radius: 20px !important;
  color: #039be5 !important;
  text-decoration: underline;
  border: 0;
  background: transparent;
  margin-bottom: 30px;
  cursor: pointer;
`;

export const ButtonClose = styled(CloseIcon)`
  cursor: pointer;
`;

export const ContainerButton = styled.div`
  display: flex;
  gap: 20px;
  button {
    width: 160px !important;
  }
`;

export const TextFieldReason = styled(TextField)`
  width: 100%;
  margin-bottom: 32px !important;
  border-radius: 8px !important;
`;

export const ContainerTextField = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
`;

export const InputLabelContainer = styled(InputLabel)`
  width: 100% !important;
  position: relative !important;
  font-size: 20px !important;
`;

export const ContainerOrdersKanban = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: calc(100vh - 227px);
  padding: 8px 8px 16px 8px;
  gap: 8px;
  overflow-x: auto;
  min-width: 1464px;
`;

export const ContainerOrdersList = styled.div`
  display: flex;
  background: rgba(0, 0, 0, 0.12);
  height: 100%;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  min-width: 480px;
  padding: 16px 16px 32px 16px;
  gap: 16px;
  @media (max-width: 1200px) {
    padding: 8px 8px 32px 8px;
    width: 465px;
  }

  ::-webkit-scrollbar {
    background-color: #f3f5f9;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.12);
  }
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 8px solid rgba(0, 0, 0, 0.38);
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
`;
